
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/paslaugos",
      function () {
        return require("private-next-pages/lt/sub/paslaugos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/paslaugos"])
      });
    }
  